import {
  Directive,
  HostBinding,
  Input
} from '@angular/core';
import { AppConstants } from '@utils/app.constants';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMStyleDirectiveBase } from './lm-style-directive.base';

@Directive({
  selector: '[lm-field-style]'  // tslint:disable-line
})
export class LMFieldStyleDirective extends LMStyleDirectiveBase {

  @Input() displayAsText: boolean;
  @Input() specField: LMSpecField;

  @Input() set fieldStyle(fieldStyle: LMFieldStyle) {
    this._fieldStyle = fieldStyle;
    this.setStyle(fieldStyle);
  }
  get fieldStyle(): LMFieldStyle {
    return this._fieldStyle;
  }
  private _fieldStyle: LMFieldStyle;

  constructor(private lmThemeService: LMThemeService) {
    super();
  }

  @HostBinding('class.alignRight') get isAlignRight() {
    if (!this.specField) {
      return false;
    }

    return this.alignRight();
  }

  // force certain types to be left-aligned
  @HostBinding('class.alignLeftForce') get isAlignLeftForce() {
    if (!this.specField) {
      return false;
    }

    return !this.alignRight();
  }

  private alignRight(): boolean {
    // 1 - check if state field
    if (this.specField.hasUserDefinedStates
      || this.specField.stateValues
      || this.specField.selectable) {
      return false;
    }

    // 2 - check if numeric key field
    if ((this.specField.isContextKey
      || this.specField.isKeyField
      || this.specField.isSymbolicKey
      || this.specField.isPartOfRelativeKey)
      && this.specField.type === AppConstants.NUMERIC) {
      return false;
    }

    // 3 & 4 = check if alpharight or if a number type
    if ((this.specField.type === AppConstants.ALPHARIGHT && !this.displayAsText)
      || this.specField.type === AppConstants.BCD
      || this.specField.type === AppConstants.PERCENT
      || this.specField.type === AppConstants.NUMERIC) {
      return true;
    }

    return false;
  }
}
